import { jsx, jsxs } from "react/jsx-runtime";
const Clock = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V7Z",
                fill: "none",
                className: "tw-fill-current"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
                fill: "none",
                className: "tw-fill-current"
            })
        ]
    });
const Clock_Clock = Clock;
export default Clock_Clock;
